import { AdminProductFamiliesQuery } from '../vsSubscriptionApiInjected';

export function transformAdminProductFamily(resp: AdminProductFamiliesQuery) {
  return resp.adminProductFamilies;
}
